import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import {
  addRouteWithTrailerAndWaypoint,
  archiveRoute,
} from "../../../ducks/routes";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../redux-store";
import { ControlPoint } from "@mui/icons-material";
import { useActions } from "../../../hooks/useActions";
import useNavigateToRoute from "../../../hooks/useNavigateToRoute";
import { useFeature } from "../../../hooks";

export default function ArchiveRouteButton(props: {
  routeId: string;
  archiveAndCreateNew?: boolean;
}) {
  const { t } = useTranslation(["dispatching", "components"]);
  const { routeId, archiveAndCreateNew } = props;
  const liteVersion = useFeature("lite-version");
  const dispatch = useAppDispatch();
  const actions = useActions({ addRouteWithTrailerAndWaypoint });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const navigateToRoute = useNavigateToRoute();

  const handleArchiveRoute = () => {
    if (archiveAndCreateNew) {
      actions
        .addRouteWithTrailerAndWaypoint({ routeId })
        .then((x) => {
          navigateToRoute(x.route.id);
        })
        .catch(() => {
          // The archiveRouteAndCreateNew thunk has already reported it and shown the error toast.
        });
    } else {
      dispatch(archiveRoute({ id: routeId })).then(() => {
        navigateToRoute(null);
      });
    }
  };

  return (
    <>
      <Button
        variant={archiveAndCreateNew ? "outlined" : "contained"}
        color="primary"
        startIcon={<ControlPoint />}
        onClick={handleClick}
      >
        {archiveAndCreateNew
          ? t("dispatching:openRouteView.endRouteAndContinue")
          : liteVersion
            ? t("dispatching:liteVersion.saveRouteAndClose")
            : t("dispatching:openRouteView.endRoute")}
      </Button>
      <Popper sx={{ zIndex: 1 }} open={open} anchorEl={anchorEl}>
        <Paper>
          <DialogTitle> {t("dispatching:openRouteView.endRoute")}</DialogTitle>
          <DialogContent>
            {t("dispatching:openRouteView.youAreEndingARoute")}
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" color="primary" onClick={handleClick}>
              {t("components:buttonLabels.cancel")}
            </Button>
            <Button variant="contained" onClick={handleArchiveRoute}>
              {t("components:buttonLabels.confirm")}
            </Button>
          </DialogActions>
        </Paper>
      </Popper>
    </>
  );
}
